import { Link } from "react-router-dom";

const quickLinks = [
  { label: "电影分类", path: "/category/movie" },
  { label: "电视剧分类", path: "/category/tv" },
  { label: "影视资讯", path: "/news" },
  { label: "搜索影视", path: "/search" },
  { label: "关于我们", path: "/about" },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="mx-auto grid grid-cols-1 gap-8 px-4 py-12 sm:grid-cols-2 md:px-6 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
              <i className="ri-movie-2-line text-lg" />
            </span>
            <span className="font-heading text-xl font-bold text-background-50">四虎视频</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-100/80">
            四虎视频致力于为用户提供丰富的电影、电视剧和热门影视资讯，涵盖多种类型和最新内容，方便用户浏览与影视相关信息。我们以简洁高效的方式，帮助每一位影迷快速找到心仪的作品。
          </p>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold text-background-50">
            <Link to="/">快速导航</Link>
          </h4>
          <ul className="mt-4 space-y-2.5">
            {quickLinks.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className="text-sm text-primary-100/75 transition-colors hover:text-accent-400"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold text-background-50">
            <Link to="/about">联系我们</Link>
          </h4>
          <ul className="mt-4 space-y-2.5 text-sm text-primary-100/75">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-base" />
              反馈邮箱：support@sihuvideo.com
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-base" />
              服务时间：每日 09:00 - 22:00
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-information-line text-base" />
              本站内容仅供演示浏览
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800/60">
        <div className="mx-auto flex flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-primary-100/60 sm:flex-row md:px-6">
          <p>© 2026 四虎视频 · 专业影视内容平台 · 保留所有权利</p>
          <p className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
            <span>友情提示：本站为影视内容演示站点</span>
            <Link to="/about" className="transition-colors hover:text-accent-400">
              免责声明
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}